// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: grey;
  opacity: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-backdrop-absolute {
  position: absolute !important;
}

.modal-backdrop-dark {
  opacity: 0.8;
}

.modal-backdrop-low {
  z-index: 0;
}

.modal-backdrop-click-through {
  pointer-events: none;
}

.modal-foreground {
  display: contents;
}

.modal-foreground > * {
  z-index: 1;
}

.modal-foreground-low > * {
  z-index: 0;
}

.shake > * {
  animation-name: shake;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-10px);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(10px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/modal-backdrop/ModalBackdrop.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE;;IAEE,wBAAwB;EAC1B;EACA;;;;;IAKE,4BAA4B;EAC9B;EACA;;;;IAIE,2BAA2B;EAC7B;AACF","sourcesContent":[".modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: grey;\n  opacity: 0.5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.modal-backdrop-absolute {\n  position: absolute !important;\n}\n\n.modal-backdrop-dark {\n  opacity: 0.8;\n}\n\n.modal-backdrop-low {\n  z-index: 0;\n}\n\n.modal-backdrop-click-through {\n  pointer-events: none;\n}\n\n.modal-foreground {\n  display: contents;\n}\n\n.modal-foreground > * {\n  z-index: 1;\n}\n\n.modal-foreground-low > * {\n  z-index: 0;\n}\n\n.shake > * {\n  animation-name: shake;\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n@keyframes shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translateX(-10px);\n  }\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translateX(10px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
